"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _LoadingOutlined2 = _interopRequireDefault(require("@zenlayer/zen-design-icons/assets/LoadingOutlined.svg"));
var _ahooks = require("ahooks");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _insertRipple = _interopRequireDefault(require("../_util/insertRipple"));
var _utils = require("../_util/utils");
var _explain = _interopRequireDefault(require("../explain"));
var _icon = _interopRequireDefault(require("../icon"));
var _tooltip = _interopRequireDefault(require("../tooltip"));
var _chipsGroup = _interopRequireDefault(require("./chips-group"));
var _chipsNumber = _interopRequireDefault(require("./chips-number"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Chips = props => {
  const {
    type = 'outline',
    size = 'm',
    prefix,
    suffix,
    disabled,
    readonly,
    loading,
    error,
    tooltips,
    noPadding,
    mText,
    width,
    height,
    children,
    defaultActive: propsDefaultActive,
    active: propsActive,
    onActiveChange: propsOnActiveChange,
    onClick,
    sendChildrenProps,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    wrapClassName,
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-chips");
  const canDoSomething = !disabled && !readonly && !loading;
  const chipsRef = (0, _react.useRef)(null);
  const [active, onActiveChange] = (0, _ahooks.useControllableValue)(props, {
    defaultValue: false,
    defaultValuePropName: 'defaultActive',
    valuePropName: 'active',
    trigger: 'onActiveChange'
  });
  (0, _ahooks.useClickAway)(event => {
    canDoSomething && onActiveChange(false, event);
  }, chipsRef);
  const prefixIcon = (0, _react.useMemo)(() => {
    return prefix ? /*#__PURE__*/_react.default.cloneElement(prefix, {
      className: (0, _classnames.default)(prefix.props.className, "".concat(baseClassName, "-prefixIcon"), {
        mText
      })
    }) : null;
  }, [prefix, mText]);
  const suffixIcon = (0, _react.useMemo)(() => {
    if (loading) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: (0, _classnames.default)("".concat(baseClassName, "-suffixIcon"), {
          mText
        }),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon.default, {
          type: "LoadingOutlined",
          style: {
            display: 'block'
          }
        })
      });
    }
    return suffix ? /*#__PURE__*/_react.default.cloneElement(suffix, {
      className: (0, _classnames.default)(suffix.props.className, "".concat(baseClassName, "-suffixIcon"), {
        mText
      })
    }) : null;
  }, [suffix, loading, mText]);

  //sendChildrenProps,如果Children是一个组件，则给他传一些状态
  const childrenProps = sendChildrenProps ? {
    type,
    size,
    disabled,
    readonly,
    loading,
    error,
    active,
    onActiveChange
  } : undefined;
  const tooltipProps = (0, _react.useMemo)(() => {
    let props = {};
    if (!!tooltips) {
      props = {
        title: tooltips
      };
    }
    return props;
  }, [tooltips]);
  const attrs = (0, _utils.pickDomAttrs)(restProps);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_explain.default, {
    helperText: error === true ? undefined : error,
    wrapClassName: wrapClassName,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      ...restProps,
      className: (0, _classnames.default)(baseClassName, className, {
        ["".concat(baseClassName, "-").concat(type)]: !!type,
        ["".concat(baseClassName, "-").concat(size)]: !!size,
        ["".concat(baseClassName, "-active")]: !!active,
        ["".concat(baseClassName, "-disabled")]: !!disabled,
        ["".concat(baseClassName, "-readonly")]: !!readonly,
        ["".concat(baseClassName, "-loading")]: !!loading,
        ["".concat(baseClassName, "-error")]: !!error,
        ["".concat(baseClassName, "-with-prefixIcon")]: !!prefixIcon,
        ["".concat(baseClassName, "-with-suffixIcon")]: !!suffixIcon
      }),
      ref: ref => {
        (0, _insertRipple.default)({
          ref
        });
        chipsRef.current = ref;
      },
      style: {
        width,
        height: height !== null && height !== void 0 ? height : mText ? 'auto' : undefined,
        minHeight: mText,
        ...style
      },
      onClick: e => {
        if (canDoSomething) {
          onActiveChange(true);
          onClick === null || onClick === void 0 || onClick(e);
        }
      },
      children: [prefixIcon, suffixIcon, /*#__PURE__*/(0, _jsxRuntime.jsx)(_tooltip.default, {
        placement: "top",
        title: undefined,
        getPopupContainer: target => target.parentNode,
        ...tooltipProps,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: (0, _classnames.default)("".concat(baseClassName, "-content"), {
            noPadding
          }),
          children: /*#__PURE__*/_react.default.isValidElement(children) ? /*#__PURE__*/_react.default.cloneElement(children, childrenProps) : children
        })
      })]
    })
  });
};
Chips.Number = _chipsNumber.default;
Chips.Group = _chipsGroup.default;
var _default = exports.default = Chips;